/**
 * Return if task has children
 * @param {Number} taskId
 * @param {Gantt} gantt
 * @returns {Boolean}
 */
function hasChild(taskId, gantt) {
  return gantt.getTaskBy('parent', taskId)?.filter((task) => task.type !== 'placeholder')?.length > 0;
}

module.exports = { hasChild };
